import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  TextInput,
  FlatList,
  RefreshControl,
  ActivityIndicator,
} from 'react-native';
import { Ionicons, FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// JOBENG Logo component
const JobengLogo = () => (
  <Image
    source={require('../../../assets/jobeng_icon.png')}
    style={{ width: 30, height: 30 }}
    resizeMode="contain"
  />
);

export default function CareerFairsScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_careerfairsscreen`;
    apiFetch('/api/data/jobs?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedSort, setSelectedSort] = useState('Date');
  const [error, setError] = useState(null);

  // Mock data for career fairs
  const mockEvents = [
    {
      id: '1',
      title: 'UK Engineering Career Fair 2025',
      organizer: 'Engineering UK',
      location: 'ExCeL London',
      address: 'Royal Victoria Dock, London E16 1XL',
      date: '2025-07-15',
      time: '10:00 - 17:00',
      description:
        'The largest engineering career fair in the UK, featuring over 200 employers from various engineering disciplines. Perfect for recent graduates and early career professionals.',
      attendees: [
        'Rolls-Royce',
        'BAE Systems',
        'Arup',
        'Dyson',
        'Jaguar Land Rover',
        'Network Rail',
        'BP',
        'Shell',
        'Airbus',
        'Mott MacDonald',
      ],
      logo: 'https://example.com/engineering-uk-logo.png',
      category: 'Engineering',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://engineeringuk.com/careerfair2025',
      features: [
        'CV reviews',
        'Mock interviews',
        'Industry panels',
        'Networking sessions',
      ],
      image: 'https://example.com/engineering-fair-image.jpg',
    },
    {
      id: '2',
      title: 'Virtual Tech Careers Expo',
      organizer: 'TechUK',
      location: 'Online',
      address: 'Virtual Event',
      date: '2025-08-05',
      time: '09:00 - 18:00',
      description:
        'A virtual career fair focused on technology roles across the UK. Connect with leading tech companies, startups, and scale-ups from the comfort of your home.',
      attendees: [
        'Google',
        'Microsoft',
        'Amazon',
        'Meta',
        'IBM',
        'Oracle',
        'Salesforce',
        'Spotify',
        'Deliveroo',
        'Monzo',
      ],
      logo: 'https://example.com/techuk-logo.png',
      category: 'Technology',
      isVirtual: true,
      isFree: true,
      registrationLink: 'https://techuk.org/virtualexpo2025',
      features: [
        'Virtual booths',
        'Live Q&A sessions',
        'Digital CV drops',
        'Video interviews',
      ],
      image: 'https://example.com/virtual-tech-expo.jpg',
    },
    {
      id: '3',
      title: 'Finance & Banking Graduate Fair',
      organizer: 'London School of Economics',
      location: 'LSE Campus',
      address: 'Houghton Street, London WC2A 2AE',
      date: '2025-09-20',
      time: '11:00 - 16:00',
      description:
        'A specialized career fair for graduates interested in finance, banking, and related fields. Meet representatives from leading financial institutions and learn about graduate opportunities.',
      attendees: [
        'HSBC',
        'Barclays',
        'Goldman Sachs',
        'JP Morgan',
        'Morgan Stanley',
        'Deloitte',
        'PwC',
        'EY',
        'KPMG',
        'Bank of England',
      ],
      logo: 'https://example.com/lse-logo.png',
      category: 'Finance',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://lse.ac.uk/financefair2025',
      features: [
        'Assessment center workshops',
        'Application advice',
        'Industry insights',
        'Alumni networking',
      ],
      image: 'https://example.com/finance-fair.jpg',
    },
    {
      id: '4',
      title: 'Healthcare Careers Exhibition',
      organizer: 'NHS Employers',
      location: 'Manchester Central',
      address: 'Windmill Street, Manchester M2 3GX',
      date: '2025-10-10',
      time: '09:30 - 16:30',
      description:
        'Explore careers in healthcare, from clinical roles to research and administration. Meet NHS trusts, private healthcare providers, and medical technology companies.',
      attendees: [
        'NHS England',
        'Bupa',
        'AstraZeneca',
        'GSK',
        'Pfizer',
        'Boots',
        'Spire Healthcare',
        'BMI Healthcare',
        'Nuffield Health',
        'Care UK',
      ],
      logo: 'https://example.com/nhs-employers-logo.png',
      category: 'Healthcare',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://nhsemployers.org/careersexhibition2025',
      features: [
        'Career pathway guidance',
        'Professional registration advice',
        'Training opportunities',
        'Volunteering information',
      ],
      image: 'https://example.com/healthcare-exhibition.jpg',
    },
    {
      id: '5',
      title: 'Creative Industries Job Fair',
      organizer: 'Creative UK',
      location: 'Tobacco Dock',
      address: 'Tobacco Quay, Wapping Lane, London E1W 2SF',
      date: '2025-08-25',
      time: '10:00 - 18:00',
      description:
        'A career fair dedicated to opportunities in creative industries including design, media, advertising, publishing, and digital content creation.',
      attendees: [
        'BBC',
        'ITV',
        'Channel 4',
        'WPP',
        'Publicis',
        'Penguin Random House',
        'Universal Music',
        'Sony Pictures',
        'VICE Media',
        'Condé Nast',
      ],
      logo: 'https://example.com/creative-uk-logo.png',
      category: 'Creative',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://creativeuk.com/jobfair2025',
      features: [
        'Portfolio reviews',
        'Creative workshops',
        'Industry speakers',
        'Freelance advice',
      ],
      image: 'https://example.com/creative-job-fair.jpg',
    },
    {
      id: '6',
      title: 'STEM Careers Festival',
      organizer: 'STEM Learning UK',
      location: 'NEC Birmingham',
      address: 'North Ave, Marston Green, Birmingham B40 1NT',
      date: '2025-09-05',
      time: '09:00 - 17:00',
      description:
        'A comprehensive career festival covering Science, Technology, Engineering, and Mathematics. Ideal for graduates and early career professionals in STEM fields.',
      attendees: [
        'Siemens',
        'ARM',
        'National Grid',
        'Thales',
        'Roche',
        'UK Space Agency',
        'Atkins',
        'Jacobs',
        'Leonardo',
        'UK Atomic Energy Authority',
      ],
      logo: 'https://example.com/stem-learning-logo.png',
      category: 'STEM',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://stemlearning.uk/careersfestival2025',
      features: [
        'Hands-on demonstrations',
        'Research showcases',
        'Career development talks',
        'Graduate scheme information',
      ],
      image: 'https://example.com/stem-festival.jpg',
    },
    {
      id: '7',
      title: 'Public Sector Graduate Recruitment Fair',
      organizer: 'Civil Service Fast Stream',
      location: 'QEII Centre',
      address: 'Broad Sanctuary, Westminster, London SW1P 3EE',
      date: '2025-07-30',
      time: '10:00 - 16:00',
      description:
        'Discover graduate opportunities across the UK public sector, including the Civil Service Fast Stream, NHS Graduate Management Training Scheme, and local government programs.',
      attendees: [
        'Civil Service Fast Stream',
        'NHS Leadership Academy',
        'MI5',
        'GCHQ',
        'Ministry of Defence',
        'Foreign, Commonwealth & Development Office',
        'HM Treasury',
        'Department for Education',
        'Local Government Association',
        'Bank of England',
      ],
      logo: 'https://example.com/civil-service-logo.png',
      category: 'Public Sector',
      isVirtual: false,
      isFree: true,
      registrationLink: 'https://faststream.gov.uk/recruitmentfair2025',
      features: [
        'Application masterclasses',
        'Assessment center preparation',
        'Fast Stream alumni talks',
        'Public service career paths',
      ],
      image: 'https://example.com/public-sector-fair.jpg',
    },
    {
      id: '8',
      title: 'Diversity in Tech Careers Fair',
      organizer: 'Tech Talent Charter',
      location: 'Hybrid - London & Online',
      address: 'Business Design Centre, London N1 0QH & Virtual',
      date: '2025-08-15',
      time: '10:00 - 17:00',
      description:
        'A hybrid career fair focused on promoting diversity and inclusion in the technology sector. Connect with employers committed to building diverse tech teams.',
      attendees: [
        'Google',
        'Microsoft',
        'Accenture',
        'Capgemini',
        'Sky',
        'BBC',
        'Vodafone',
        'BT',
        'Lloyds Banking Group',
        'Nationwide',
      ],
      logo: 'https://example.com/tech-talent-charter-logo.png',
      category: 'Technology',
      isVirtual: true,
      isFree: true,
      registrationLink: 'https://techtalentcharter.org/diversityfair2025',
      features: [
        'Mentoring sessions',
        'Inclusive recruitment workshops',
        'Returnship programs',
        'Accessibility in tech talks',
      ],
      image: 'https://example.com/diversity-tech-fair.jpg',
    },
  ];

  // Filter options
  const filterOptions = [
    'All',
    'Engineering',
    'Technology',
    'Finance',
    'Healthcare',
    'Creative',
    'STEM',
    'Public Sector',
    'Virtual',
  ];

  // Sort options
  const sortOptions = ['Date', 'Location', 'Organizer'];

  // Load events when component mounts
  useEffect(() => {
    loadEvents();
  }, []);

  // Load events
  const loadEvents = () => {
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      try {
        setEvents(mockEvents);
        setFilteredEvents(mockEvents);
        setError(null);
      } catch (err) {
        setError('Failed to load career fairs');
        console.error('Error loading events:', err);
      } finally {
        setIsLoading(false);
      }
    }, 1000);
  };

  // Handle search
  useEffect(() => {
    if (searchQuery.trim() === '') {
      applyFilters(selectedFilter, selectedSort);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = events.filter(
        event =>
          String(event.title ?? '').toLowerCase().includes(query) ||
          String(event.organizer ?? '').toLowerCase().includes(query) ||
          String(event.location ?? '').toLowerCase().includes(query) ||
          String(event.category ?? '').toLowerCase().includes(query) ||
          event.attendees.some(attendee =>
            attendee.toLowerCase().includes(query)
          )
      );
      setFilteredEvents(sortEvents(filtered, selectedSort));
    }
  }, [searchQuery, selectedFilter, selectedSort, events]);

  // Apply filters
  const applyFilters = (filter, sort) => {
    setSelectedFilter(filter);
    setSelectedSort(sort);

    let filtered = [...events];

    // Apply category filter
    if (filter !== 'All') {
      if (filter === 'Virtual') {
        filtered = filtered.filter(event => event.isVirtual);
      } else {
        filtered = filtered.filter(event => event.category === filter);
      }
    }

    // Apply sort
    filtered = sortEvents(filtered, sort);

    setFilteredEvents(filtered);
  };

  // Sort events
  const sortEvents = (events, sortBy) => {
    const sorted = [...events];

    switch (sortBy) {
      case 'Date':
        return sorted.sort((a, b) => new Date(a.date) - new Date(b.date));
      case 'Location':
        return sorted.sort((a, b) => a.location.localeCompare(b.location));
      case 'Organizer':
        return sorted.sort((a, b) => a.organizer.localeCompare(b.organizer));
      default:
        return sorted;
    }
  };

  // Format date
  const formatDate = dateString => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  // Calculate days until event
  const getDaysUntilEvent = eventDate => {
    const today = new Date();
    const date = new Date(eventDate);
    const diffTime = date - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  // Render event item
  const renderEventItem = ({ item }) => {
    const daysUntil = getDaysUntilEvent(item.date);
    const isPast = daysUntil < 0;
    const isSoon = daysUntil >= 0 && daysUntil <= 14;

    return (
      <TouchableOpacity
        style={styles.eventCard}
        onPress={() =>
          navigation.navigate('CareerFairDetails', { eventId: item.id })
        }
      >
        <View style={styles.cardHeader}>
          <View style={styles.dateContainer}>
            <Text style={styles.dateMonth}>
              {new Date(item.date).toLocaleDateString('en-GB', {
                month: 'short',
              })}
            </Text>
            <Text style={styles.dateDay}>{new Date(item.date).getDate()}</Text>
          </View>

          <View style={styles.headerInfo}>
            <Text style={styles.eventTitle}>{item.title}</Text>
            <Text style={styles.eventOrganizer}>{item.organizer}</Text>
          </View>

          {item.isVirtual && (
            <View style={styles.virtualBadge}>
              <Ionicons name="globe-outline" size={14} color="#0ea5e9" />
              <Text style={styles.virtualBadgeText}>Virtual</Text>
            </View>
          )}
        </View>

        <View style={styles.cardDetails}>
          <View style={styles.detailItem}>
            <Ionicons name="location-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{item.location}</Text>
          </View>

          <View style={styles.detailItem}>
            <Ionicons name="time-outline" size={16} color="#64748B" />
            <Text style={styles.detailText}>{item.time}</Text>
          </View>

          <View style={styles.badgeContainer}>
            <View style={[styles.badge, styles.categoryBadge]}>
              <Text style={styles.categoryBadgeText}>{item.category}</Text>
            </View>
            {item.isFree && (
              <View style={[styles.badge, styles.freeBadge]}>
                <Text style={styles.freeBadgeText}>Free Entry</Text>
              </View>
            )}
          </View>
        </View>

        <View style={styles.attendeesContainer}>
          <Text style={styles.attendeesTitle}>Featured Employers:</Text>
          <Text style={styles.attendeesList}>
            {item.attendees.slice(0, 5).join(', ')}
            {item.attendees.length > 5
              ? ` and ${item.attendees.length - 5} more`
              : ''}
          </Text>
        </View>

        <View style={styles.cardFooter}>
          <View style={styles.statusContainer}>
            {isPast ? (
              <Text style={styles.pastEventText}>Event has ended</Text>
            ) : isSoon ? (
              <Text style={styles.soonEventText}>
                {daysUntil === 0
                  ? 'Today!'
                  : daysUntil === 1
                    ? 'Tomorrow!'
                    : `${daysUntil} days away`}
              </Text>
            ) : (
              <Text style={styles.upcomingEventText}>
                {formatDate(item.date)}
              </Text>
            )}
          </View>

          <TouchableOpacity
            style={[styles.registerButton, isPast && styles.disabledButton]}
            disabled={isPast}
            onPress={() =>
              navigation.navigate('CareerFairRegistration', {
                eventId: item.id,
              })
            }
          >
            <Text style={styles.registerButtonText}>
              {isPast ? 'Ended' : 'Register'}
            </Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // Render filter chip
  const renderFilterChip = filter => (
    <TouchableOpacity
      key={filter}
      style={[
        styles.filterChip,
        selectedFilter === filter && styles.activeFilterChip,
      ]}
      onPress={() => applyFilters(filter, selectedSort)}
    >
      <Text
        style={[
          styles.filterChipText,
          selectedFilter === filter && styles.activeFilterChipText,
        ]}
      >
        {filter}
      </Text>
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#ffffff" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Career Fairs</Text>
        <JobengLogo />
      </View>

      {/* Search Bar */}
      <View style={styles.searchContainer}>
        <View style={styles.searchBar}>
          <Ionicons
            name="search"
            size={20}
            color="#64748B"
            style={styles.searchIcon}
          />
          <TextInput
            style={styles.searchInput}
            placeholder="Search events, employers, locations..."
            placeholderTextColor="#94A3B8"
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity
              style={styles.clearButton}
              onPress={() => setSearchQuery('')}
            >
              <Ionicons name="close-circle" size={18} color="#64748B" />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* Filters */}
      <View style={styles.filtersContainer}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={styles.filtersScrollContent}
        >
          {filterOptions.map(renderFilterChip)}
        </ScrollView>

        <TouchableOpacity
          style={styles.sortButton}
          onPress={() => {
            // In a real app, this would open a sort modal or dropdown
            // For this example, we'll just cycle through sort options
            const currentIndex = sortOptions.indexOf(selectedSort);
            const nextIndex = (currentIndex + 1) % sortOptions.length;
            applyFilters(selectedFilter, sortOptions[nextIndex]);
          }}
        >
          <Ionicons name="options-outline" size={20} color="#0e4e96" />
          <Text style={styles.sortButtonText}>Sort: {selectedSort}</Text>
        </TouchableOpacity>
      </View>

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading career fairs...</Text>
        </View>
      ) : error ? (
        <View style={styles.errorContainer}>
          <Ionicons name="alert-circle-outline" size={60} color="#dc2626" />
          <Text style={styles.errorTitle}>Error</Text>
          <Text style={styles.errorDescription}>{error}</Text>
          <TouchableOpacity style={styles.retryButton} onPress={loadEvents}>
            <Text style={styles.retryButtonText}>Retry</Text>
          </TouchableOpacity>
        </View>
      ) : (
        <FlatList
          data={filteredEvents}
          renderItem={renderEventItem}
          keyExtractor={item => item.id}
          contentContainerStyle={styles.listContainer}
          showsVerticalScrollIndicator={false}
          ListEmptyComponent={
            <View style={styles.emptyContainer}>
              <Ionicons name="calendar-outline" size={60} color="#94A3B8" />
              <Text style={styles.emptyTitle}>No career fairs found</Text>
              <Text style={styles.emptyDescription}>
                Try adjusting your search or filters to find more events
              </Text>
            </View>
          }
        />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#F8FAFC',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  searchContainer: {
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  searchBar: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F1F5F9',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  searchIcon: {
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    height: 40,
    fontSize: 16,
    color: '#0F172A',
  },
  clearButton: {
    padding: 4,
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    backgroundColor: '#ffffff',
  },
  filtersScrollContent: {
    paddingHorizontal: 16,
  },
  filterChip: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    backgroundColor: '#F1F5F9',
    marginRight: 8,
  },
  activeFilterChip: {
    backgroundColor: '#0e4e96',
  },
  filterChipText: {
    fontSize: 14,
    color: '#64748B',
    fontWeight: '500',
  },
  activeFilterChipText: {
    color: '#ffffff',
  },
  sortButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  sortButtonText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
    marginLeft: 4,
  },
  listContainer: {
    padding: 16,
  },
  eventCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    marginBottom: 16,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 5,
    elevation: 2,
  },
  cardHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  dateContainer: {
    width: 50,
    height: 50,
    borderRadius: 8,
    backgroundColor: '#0e4e96',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  dateMonth: {
    fontSize: 12,
    fontWeight: '600',
    color: '#ffffff',
    textTransform: 'uppercase',
  },
  dateDay: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  headerInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  eventTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0F172A',
    marginBottom: 4,
  },
  eventOrganizer: {
    fontSize: 14,
    color: '#64748B',
  },
  virtualBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#0ea5e9' + '20',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    alignSelf: 'flex-start',
  },
  virtualBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#0ea5e9',
    marginLeft: 4,
  },
  cardDetails: {
    marginBottom: 12,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
  },
  detailText: {
    fontSize: 14,
    color: '#64748B',
    marginLeft: 8,
  },
  badgeContainer: {
    flexDirection: 'row',
    marginTop: 8,
  },
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginRight: 8,
  },
  categoryBadge: {
    backgroundColor: '#8b5cf6' + '20',
  },
  categoryBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#8b5cf6',
  },
  freeBadge: {
    backgroundColor: '#10b981' + '20',
  },
  freeBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#10b981',
  },
  attendeesContainer: {
    marginBottom: 12,
  },
  attendeesTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: 4,
  },
  attendeesList: {
    fontSize: 14,
    color: '#64748B',
    lineHeight: 20,
  },
  cardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#F1F5F9',
    paddingTop: 12,
  },
  statusContainer: {
    flex: 1,
  },
  upcomingEventText: {
    fontSize: 14,
    color: '#0F172A',
  },
  soonEventText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#f59e0b',
  },
  pastEventText: {
    fontSize: 14,
    color: '#94A3B8',
  },
  registerButton: {
    backgroundColor: '#0e4e96',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  disabledButton: {
    backgroundColor: '#94A3B8',
  },
  registerButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748B',
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#dc2626',
    marginTop: 12,
    marginBottom: 8,
  },
  errorDescription: {
    fontSize: 16,
    color: '#64748B',
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  retryButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '600',
  },
  emptyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 40,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#64748B',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyDescription: {
    fontSize: 14,
    color: '#94A3B8',
    textAlign: 'center',
  },
});
